import {ExclamationCircleFilled} from "@ant-design/icons";

const deleteModal = {
    title: 'Delete element',
    content: 'If you delete an element from a table, it will be deleted permanently. Are you sure you want to proceed?',
    okText: 'Delete',
    cancelText: 'Cancel',
}

const configDefault = ({title, content, okText, cancelText}) =>{
    return {
        className: 'confirm_modal',
        width: 550,
        icon: null,
        title: (
            <>
                <ExclamationCircleFilled />
                <div className={'confirm_modal_title'}>
                    {title ? title : 'Confirm'}
                </div>
            </>
        ),
        content: (
            <>
                {content ? content : 'Bla bla bla....'}
                <hr/>
            </>
        ),
        okText: okText ? okText : 'Confirm',
        cancelText: cancelText ? cancelText : 'Cancel',
        centered: true,
        cancelButtonProps: {
            type: 'text'
        },
    }
}

const getConfigByType = (type) =>{
    switch (type){
        case 'delete':
            return deleteModal
        default:
            return {}
    }
}

export const configConfirmModal = ({type, ...rest}) =>{
    if (type){
        const config = getConfigByType(type)
        return {
            ...configDefault(config),
            ...rest,
        }
    }

    return {
        ...configDefault({}),
        ...rest,
    }
}